var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "12806051-c6ae-463a-be3d-985baf9cc53b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 215,
    height: 140,
    viewBox: "0 0 215 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "7363048e-be20-43e3-b8aa-93d427cf449a",
    x1: 170.42,
    y1: 103.55,
    x2: 0,
    y2: 103.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff638a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#fc0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ff9a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LowPass") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 215,
    height: 140,
    style: {
      fill: "#262728"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,68.1H93.18c33,0,76.24,9.09,76.24,71.9H0Z",
    style: {
      fill: "#fff",
      opacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,68.1H93.18c33,0,76.24,9.09,76.24,71.9",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#7363048e-be20-43e3-b8aa-93d427cf449a)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowPass);
export default __webpack_public_path__ + "static/media/LowPass.54635daa.svg";
export { ForwardRef as ReactComponent };